import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { RoblokyProvider, useRobloky } from './context/RoblokyContext';
import { Navbar } from './components/layout/Navbar';
import { MobileNav } from './components/layout/MobileNav';
import { GamesGrid } from './components/games/GamesGrid';
import { GameDetail } from './components/games/GameDetail';
import { SavedView } from './components/games/SavedView';
import { ProfileView } from './components/profile/ProfileView';
import { AdminPanel } from './components/admin/AdminPanel';
import { AuthModal } from './components/auth/AuthModal';
import { ToastContainer } from './components/layout/ToastContainer';
import { basePrefix } from './utils/format';

const Shell: React.FC = () => {
  const { view, isAuthModalOpen, closeAuthModal, authModalMode, isAdminPanelOpen } = useRobloky();
  const base = basePrefix();

  return (
    <div className="min-h-screen bg-[#090b10] text-[#e2e8f0] flex flex-col selection:bg-red-500/30 selection:text-red-200">
      <Navbar />

      <main className="flex-1 w-full max-w-7xl mx-auto px-3 sm:px-6 pt-4 sm:pt-6 pb-24 md:pb-12">
        {view.name === 'home' && <GamesGrid />}
        {view.name === 'game' && <GameDetail placeId={view.placeId} />}
        {view.name === 'saved' && <SavedView />}
        {view.name === 'profile' && <ProfileView />}
      </main>

      <footer className="border-t border-white/5 bg-[#07090e] py-6 px-4 sm:px-6">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs font-mono text-slate-500">
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-slate-400 font-bold">ROBLOKY</span>
            <span className="hidden sm:inline text-slate-700">â€¢</span>
            <span className="hidden sm:inline">Roblox game directory â€” screenshots, live stats & player reviews</span>
          </div>
          <div className="flex items-center gap-4">
            <a href={`${base}/about`} className="hover:text-slate-300">About</a>
            <a href={`${base}/terms`} className="hover:text-slate-300">Terms</a>
            <a href={`${base}/sitemap.xml`} className="hover:text-slate-300">Sitemap</a>
          </div>
        </div>
      </footer>

      <MobileNav />
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={closeAuthModal}
        initialMode={authModalMode}
      />
      {isAdminPanelOpen && <AdminPanel />}
      <ToastContainer />
    </div>
  );
};

export default function App() {
  return (
    <AuthProvider>
      <RoblokyProvider>
        <Shell />
      </RoblokyProvider>
    </AuthProvider>
  );
}
